import { render, staticRenderFns } from "./SuggestedDatingPage.vue?vue&type=template&id=1fd2ed16&scoped=true"
import script from "./SuggestedDatingPage.vue?vue&type=script&lang=js"
export * from "./SuggestedDatingPage.vue?vue&type=script&lang=js"
import style0 from "./SuggestedDatingPage.vue?vue&type=style&index=0&id=1fd2ed16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2ed16",
  null
  
)

export default component.exports